
define('text!modules/player/zone_media_list_actions_template.html',[],function () { return '<div class="page-actions zone-actions">\r\n  <a href="/ads?zone_id=<%- zone_id %>" class="button"><%- _.t(\'screen.button.add_existing_ad\') %></a>\r\n  <a href="/templates?zone_id=<%- zone_id %>" class="button button-primary"><%- _.t(\'screen.button.create_new_ad\') %></a>\r\n</div>\r\n';});

